module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dyGV0"))).then(() => parcelRequire('hEqeo'));